import {
  faArrowLeftLong,
  faPersonChalkboard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  baseURL,
  EDITANNOUNCEMNT,
  UPDATEANNOUNCEMNT,
} from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function UpdateAds() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [data, setData] = useState({
    endDate: "",
    startDate: "",
    content: "",
    type: "text",
    icon: "faBell",
    isSticky: false,
    isActive: true,
    displayType: "ticker",
    scrollSpeed: "normal",
    scrollDirection: "right"
  });

  // جلب بيانات الإعلان للتعديل
  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${EDITANNOUNCEMNT}/${id}/`)
        .then((res) => { 
          const item = res.data.data;
          if (item) {
            setData({ 
              content: item.content || "", 
              endDate: item.end_date ? item.end_date.split(/[T ]/)[0] : "", 
              startDate: item.start_date ? item.start_date.split(/[T ]/)[0] : "", 
              type: item.type || "text",
              icon: item.icon || "faBell",
              isSticky: item.is_sticky === 1 || item.is_sticky === true,
              isActive: item.is_active === 1 || item.is_active === true,
              displayType: item.display_type || "ticker",
              scrollSpeed: item.scroll_speed || "normal",
              scrollDirection: item.scroll_direction || "right"
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل بيانات الإعلان");
        });
    }
  }, [id, axiosPrivate]);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setData((prev) => ({ 
      ...prev, 
      [name]: type === "checkbox" ? checked : value 
    }));
  }

  async function handleSubmit(nav, save) {
    if (!data.content.trim()) {
      toast.error("يرجى إدخال محتوى الإعلان");
      return;
    }

    setLoding(true);

    try {
      const response = await axiosPrivate.put(
        `${baseURL}/${UPDATEANNOUNCEMNT}/`,
        {
          ...data,
          save,
          id,
        }
      );

      toast.success("تم الحفظ بنجاح");

      if (nav) {
        Navigate("/DashboardLayout/ads");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);

      if (error.response && error.response.status === 400) {
        toast.error("لم يتم الحفظ، قد تكون البيانات مكررة أو غير صحيحة");
      } else {
        toast.error("حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً");
      }
    } finally {
      setLoding(false);
    }
  }

  return (
    <>
      {Loding && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/ads"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold mb-4">تعديل الإعلان الديناميكي</h2>
        
        <div className="mb-5 bg-white border p-4 p-md-5 shadow-sm rounded-4 animate__animated animate__fadeIn" style={{ borderRadius: "16px", maxWidth: "800px", marginTop: "20px" }}>
          <Form onSubmit={(e) => e.preventDefault()} className="w-100">
            
            {/* المحتوى الرئيسي للإعلان */}
            <h5 className="fw-bold text-dark mb-4 border-bottom pb-2" style={{ color: "var(--brand-300)" }}>المحتوى الأساسي</h5>
            
            <Form.Group className="mb-4 text-start">
              <Form.Label className="fw-bold mb-2">
                <FontAwesomeIcon
                  style={{ color: "var(--brand-300)" }}
                  className="me-2"
                  icon={faPersonChalkboard}
                />
                <span style={{ fontSize: "0.95rem", color: "#334155", marginRight: "8px" }}>محتوى أو نص الإعلان الرئيسي</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="content"
                value={data.content}
                onChange={handleChange}
                placeholder="اكتب نص الإعلان هنا..."
                className="form-control py-2.5 shadow-none border"
                style={{ borderRadius: "8px", fontSize: "0.95rem" }}
                required
              />
            </Form.Group>

            <div className="row g-4 mb-4">
              {/* نوع الإعلان */}
              <div className="col-md-6">
                <Form.Group className="text-start">
                  <Form.Label className="fw-bold mb-2">نوع الإعلان</Form.Label>
                  <Form.Select
                    name="type"
                    value={data.type}
                    onChange={handleChange}
                    className="form-control py-2 shadow-none border"
                    style={{ borderRadius: "8px" }}
                  >
                    <option value="text">نص فقط 📝</option>
                    <option value="icon">نص + أيقونة 🔔</option>
                    <option value="countdown">عداد تنازلي ⏳</option>
                  </Form.Select>
                </Form.Group>
              </div>

              {/* اختيار الأيقونة */}
              <div className="col-md-6">
                <Form.Group className="text-start">
                  <Form.Label className="fw-bold mb-2">الأيقونة المرافقة</Form.Label>
                  <Form.Select
                    name="icon"
                    value={data.icon}
                    onChange={handleChange}
                    disabled={data.type !== "icon" && data.type !== "countdown"}
                    className="form-control py-2 shadow-none border"
                    style={{ borderRadius: "8px" }}
                  >
                    <option value="faBell">جرس إشعارات 🔔</option>
                    <option value="faClock">ساعة / مؤقت ⏰</option>
                    <option value="faInfoCircle">معلومات ℹ️</option>
                    <option value="faGift">هدية / عرض 🎁</option>
                    <option value="faBullhorn">تنبيه / مكبر صوت 📢</option>
                    <option value="faExclamationTriangle">تحذير ⚠️</option>
                    <option value="faPercentage">خصم نسبة مئوية 🏷️</option>
                    <option value="faEnvelope">رسالة / بريد ✉️</option>
                    <option value="faQuestionCircle">مساعدة ❓</option>
                    <option value="faStar">نجمة تفضيل ⭐</option>
                    <option value="faTrophy">كأس / تميز 🏆</option>
                    <option value="faUserGraduate">تخرج / طالب 🎓</option>
                    <option value="faCheckCircle">نجاح / تأكيد ✅</option>
                    <option value="faTimesCircle">تنبيه بالرفض ❌</option>
                    <option value="faCalendarDays">تقويم 📅</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            <div className="row g-4 mb-4">
              {/* طريقة العرض */}
              <div className="col-md-6">
                <Form.Group className="text-start">
                  <Form.Label className="fw-bold mb-2">طريقة العرض الرئيسية</Form.Label>
                  <Form.Select
                    name="displayType"
                    value={data.displayType}
                    onChange={handleChange}
                    className="form-control py-2 shadow-none border"
                    style={{ borderRadius: "8px" }}
                  >
                    <option value="ticker">شريط متحرك (Marquee Ticker) 🔁</option>
                    <option value="countdown">مؤقت تنازلي (Countdown) ⏳</option>
                  </Form.Select>
                </Form.Group>
              </div>

              {/* خيار التفعيل الكلي للإعلان */}
              <div className="col-md-6 d-flex align-items-end">
                <Form.Group className="mb-2 d-flex align-items-center w-100 gap-3 border p-2 px-3 bg-light" style={{ borderRadius: "8px", minHeight: "44px" }}>
                  <Form.Check
                    type="switch"
                    id="isActive"
                    name="isActive"
                    checked={data.isActive}
                    onChange={handleChange}
                    label={<span className="fw-bold">تفعيل الإعلان فوراً للزوار</span>}
                    className="custom-switch-green"
                  />
                </Form.Group>
              </div>
            </div>

            {/* إعدادات الجدولة الزمنية */}
            <h5 className="fw-bold text-muted mb-3 border-bottom pb-2 mt-5">الجدولة الزمنية</h5>
            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <Form.Group className="text-start">
                  <Form.Label className="fw-bold mb-2">تاريخ البدء</Form.Label>
                  <Form.Control
                    type="date"
                    name="startDate"
                    value={data.startDate}
                    onChange={handleChange}
                    className="form-control py-2 shadow-none border"
                    style={{ borderRadius: "8px" }}
                  />
                  <Form.Text className="text-muted">اتركه فارغاً ليظهر فوراً</Form.Text>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="text-start">
                  <Form.Label className="fw-bold mb-2">تاريخ الانتهاء (مطلوب)</Form.Label>
                  <Form.Control
                    type="date"
                    name="endDate"
                    value={data.endDate}
                    onChange={handleChange}
                    className="form-control py-2 shadow-none border"
                    style={{ borderRadius: "8px" }}
                    required
                  />
                  <Form.Text className="text-muted">سينتهي ويختفي الإعلان تلقائياً عند هذا التاريخ</Form.Text>
                </Form.Group>
              </div>
            </div>

            {/* إعدادات حركة الشريط Ticker */}
            {data.displayType === "ticker" && (
              <>
                <h5 className="fw-bold text-muted mb-3 border-bottom pb-2 mt-5">إعدادات حركة الشريط (Ticker)</h5>
                <div className="row g-4 mb-4">
                  
                  {/* سرعة الحركة */}
                  <div className="col-md-4">
                    <Form.Group className="text-start">
                      <Form.Label className="fw-bold mb-2">سرعة الدوران</Form.Label>
                      <Form.Select
                        name="scrollSpeed"
                        value={data.scrollSpeed}
                        onChange={handleChange}
                        disabled={data.isSticky}
                        className="form-control py-2 shadow-none border"
                        style={{ borderRadius: "8px" }}
                      >
                        <option value="slow">بطيء 🐢</option>
                        <option value="normal">عادي 🚶</option>
                        <option value="fast">سريع ⚡</option>
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* اتجاه الحركة */}
                  <div className="col-md-4">
                    <Form.Group className="text-start">
                      <Form.Label className="fw-bold mb-2">اتجاه الدوران</Form.Label>
                      <Form.Select
                        name="scrollDirection"
                        value={data.scrollDirection}
                        onChange={handleChange}
                        disabled={data.isSticky}
                        className="form-control py-2 shadow-none border"
                        style={{ borderRadius: "8px" }}
                      >
                        <option value="right">لليمين (مناسب للعربية) ➡️</option>
                        <option value="left">لليسار ⬅️</option>
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {/* تثبيت الحركة */}
                  <div className="col-md-4 d-flex align-items-end">
                    <Form.Group className="mb-2 d-flex align-items-center w-100 gap-3 border p-2 px-3 bg-light" style={{ borderRadius: "8px", minHeight: "44px" }}>
                      <Form.Check
                        type="checkbox"
                        id="isSticky"
                        name="isSticky"
                        checked={data.isSticky}
                        onChange={handleChange}
                        label={<span className="fw-bold">تثبيت الشريط (منع الحركة) 📌</span>}
                      />
                    </Form.Group>
                  </div>

                </div>
              </>
            )}

            {/* أزرار التحكم والتقديم */}
            <div className="d-flex gap-3 mt-5 pt-3 border-top justify-content-end">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "10px 40px", borderRadius: "8px" }}
                className="custom-brand-btn-dhash"
              >
                تحديث وحفظ التعديلات 🚀
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "10px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                  borderRadius: "8px"
                }}
                className="custom-reset-btn border"
              >
                حفظ كمسودة 📝
              </Button>
            </div>

          </Form>
        </div>
      </div>
    </>
  );
}
